<!--
  VISOR PDF
     <ActionViewReports
       size='small'
       :unit="QUnit"
       :color="primary"
       :loading=false
     />
-->

<template>
  <div>
    <v-icon
      v-if="show_action"
      :small="size == 'small'"
      :large="size == 'large'"
      :color="color"
      :disabled="disabled || !(unit.visor_pdf_reports || {}).value"
      @click.stop="pdfViewer(unit.visor_pdf_reports)"
    >
      mdi-eye-outline
    </v-icon>
    <PDFViewer
      v-if="unit && unit.visor_pdf_reports"
      ref="pdf_viewer"
      :key="'pdf_viewer'+unit.uid"
      :unit="unit.visor_pdf_reports"
      :disabled="disabled"
      @close="refresh_unit"
    ></PDFViewer>
  </div>
</template>


<script>
 export default {
  // TODO: Cange componmet name
   name: "ActionViewReports",

   components: {
     PDFViewer : () => import('@/views/PDFViewer'),
    },

   props: {
     size: {default: 'small'},
     unit: {required: true},
     color: {},
     disabled: Boolean
   },
   
   computed: {
      show_action() {
        // unit && unit.visor_pdf_reports
        return (this.unit.visor_pdf_reports||{}).value;
      },
   },

   methods: {
     pdfViewer() {
      this.$refs.pdf_viewer.open();
      this.$emit('clicked');
     },
     refresh_unit() {
      this.$emit('refresh');
     },
   }
 };
</script>
